export default __webpack_public_path__ + "static/media/GLNVR.5cdd4d5d.webp";